import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setAdding(state, payload) {
    state.isAdding = payload;
  },
  setRefreshing(state, payload) {
    state.isRefreshing = payload;
  },
  setDdStates(state, payload) {
    state.ddStates = payload;
  },
  setRiskStates(state, payload) {
    state.riskStates = payload;
  },
  setUsers(state, payload) {
    state.list = payload;
  },
  addUsers(state, payload) {
    state.list.push(...payload);
  },
  setPaging(state, payload) {
    state.paging = payload;
  },
  setSummary(state, payload) {
    state.summary = payload;
  },
};
